import { Badge, Card, IconButton, SetupImageCarousel } from '@components'
import type { Setup } from '@here/api'
import createEmblaCarousel from 'embla-carousel-solid'
import { Play } from 'lucide-solid'
import { For, Show, createSignal } from 'solid-js'
import { css, cx } from 'styled-system/css'
import { Box, Flex } from 'styled-system/jsx'
import { aspectRatio } from 'styled-system/patterns'

export const Images = (props: { setup: Setup | null | undefined }) => {
	const [emblaRef, x] = createEmblaCarousel()
	const [isHovered, setIsHovered] = createSignal(false)
	const [openImage, setOpenImage] = createSignal<number>()

	const images = [
		{
			title: 'Pattern',
			src: props.setup?.image_pattern ?? undefined,
		},
		{
			title: 'Macro',
			src: props.setup?.image_macro ?? undefined,
		},
		{
			title: 'Trend',
			src: props.setup?.image_trend ?? undefined,
		},
		{
			title: 'Trigger',
			src: props.setup?.image_trigger ?? undefined,
		},
		{
			title: 'Time Stop',
			src: props.setup?.image_time_stop ?? undefined,
		},
		{
			title: 'Volume by price',
			src: props.setup?.image_volume_by_price ?? undefined,
		},
	].filter((image) => image.src)

	x()?.scrollNext()

	return (
		<Box position="relative">
			<SetupImageCarousel
				images={images}
				openImage={openImage}
				setIsOpen={setOpenImage}
			/>
			<div
				class={css({
					overflow: 'hidden',
					filter: props.setup?.stage === 'stopped' ? 'grayscale(1)' : '',
				})}
				ref={emblaRef}
				onMouseEnter={() => setIsHovered(true)}
				onMouseLeave={() => setIsHovered(false)}
			>
				<div
					class={css({
						display: 'flex',
					})}
				>
					<For each={images}>
						{(image, index) => (
							<Box
								flex=" 0 0 100%"
								minWidth={0}
								cursor="zoom-in"
								onClick={() => setOpenImage(index())}
							>
								<Card.Root
									style={{
										'background-image': `url(${image.src})`,
									}}
									class={cx(
										aspectRatio({ ratio: 16 / 9 }),
										css({
											backgroundSize: 'cover',
											backgroundPosition: 'center',
											width: '100%',
										}),
									)}
								/>
								<Box
									position="absolute"
									bottom={0}
									width="100%"
									textAlign="center"
									pb={2}
								>
									<Badge
										variant="subtle"
										size="sm"
										children={image.title}
									/>
								</Box>
							</Box>
						)}
					</For>
				</div>
				<Show when={isHovered()}>
					<Flex
						class={css({
							justifyContent: 'space-between',
							position: 'absolute',
							pointerEvents: 'none',
							top: '0',
							alignItems: 'center',
							width: '100%',
							height: '100%',
							left: 0,
							right: 0,
						})}
					>
						<IconButton
							pointerEvents="auto"
							colorPalette="tscGreen"
							variant="ghost"
							onClick={() => x()?.scrollPrev()}
						>
							<Play
								class={css({
									transform: 'rotate(180deg)',
								})}
								fill="var(--colors-tsc-green-default)"
							/>
						</IconButton>
						<IconButton
							pointerEvents="auto"
							colorPalette="tscGreen"
							variant="ghost"
							onClick={() => x()?.scrollNext()}
						>
							<Play fill="var(--colors-tsc-green-default)" />
						</IconButton>
					</Flex>
				</Show>
			</div>
		</Box>
	)
}
